import { NgModule } from "@angular/core";
import { HomeComponent } from "./home/home.component";
import { Route, RouterModule } from "@angular/router";

export const routes: Route[] = [
    {
        path: '**',
        component: HomeComponent
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HomeRoutingModule { }